import { render, staticRenderFns } from "./appSupport.vue?vue&type=template&id=7c076e65&"
import script from "./appSupport.vue?vue&type=script&lang=js&"
export * from "./appSupport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports